
















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

@Component({})
export default class Login extends Vue {
    private username!: string;
    private password!: string;
    private connectionError!: boolean;

    private data() {
        return {
            username: '',
            password: '',
            connectionError: false,
        };
    }

    private created() {
        if (localStorage.getItem('accessToken') !== null && localStorage.getItem('accessToken') !== '') {
            this.$router.push({ path: '/app/recipes' });
        }
    }
    
    private login() {
        this.$store.state.upWrong = false;
        this.connectionError = false;
        this.$store.dispatch('retrieveToken', {
            username: this.username,
            password: this.password,
        }).then((response) => {
            if (!this.$store.state.upWrong && this.$store.state.forwardRoute !== '') {
                this.$router.push({ path: this.$store.state.forwardRoute });
                this.$store.state.forwardRoute = '';
            } else if (!this.$store.state.upWrong) {
                this.$router.push({ path: '/app/recipes' });
                this.$store.state.infoBoxText = 'Herzlich willkommen, ' + localStorage.getItem('displayName') + '!';
            }
        }).catch((error) => {
            this.password = '';
            this.$store.state.loginLoading = false;
            this.connectionError = true;
        });
    }

    @Watch('this.$store.state.upWrong')
    private onPropertyChanged(value: boolean, oldValue: boolean) {
        if (this.$store.state.upWrong === true) {
            this.password = '';
        }
    }
}
